import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StatusCodes } from '@src/app/interceptors/status-codes.enum';
import { inject } from '@angular/core';
import { ToasterService } from '@shared/toaster-widget/toaster.service';
import { IFormFieldError, ToastType } from '@shared/toaster-widget/toaster-widget.component';
import { Router } from '@angular/router';

export interface ValidationHttpErrorResponse extends HttpErrorResponse {
  fieldErrors: [IFormFieldError];
}

export const HttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toaster = inject(ToasterService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const skipErrorInterceptorHeader = req.headers.get('skipErrorInterceptor');
      const skipErrorInterceptor: boolean = skipErrorInterceptorHeader ? JSON.parse(skipErrorInterceptorHeader) : false;

      if (err.error instanceof ErrorEvent) {
        return throwError(() => err);
      }

      if (err.error instanceof Blob) {
        return throwError(() => err);
      }

      if (skipErrorInterceptor) {
        return throwError(() => err);
      }

      switch (err.status) {
        case StatusCodes.CONNECTION_REFUSED:
          console.error('Connection refused');
          break;
        case StatusCodes.UNAUTHORIZED:
          router.navigate(['auth']);
          break;
        case StatusCodes.BAD_REQUEST:
          const errors = (err.error as ValidationHttpErrorResponse).fieldErrors;
          toaster.showWithContent(ToastType.WARNING, {
            title: 'errors.bad_request',
            errors,
          });
          break;
        case StatusCodes.UNSUPPORTED_MEDIA_TYPE:
          console.warn('Unsupported media type');
          break;
        case StatusCodes.UNPROCESSABLE_CONTENT:
          toaster.showWithContent(ToastType.ERROR, {
            message: err.error.message,
          });
          break;
        default:
          toaster.showWithContent(ToastType.WARNING, {
            title: 'errors.internal_server_error',
            message: err.error.message,
          });
          break;
      }

      return throwError(() => err);
    }),
  );
};
